import { render, staticRenderFns } from "./DataProvider.vue?vue&type=template&id=4cac0be9&scoped=true&"
import script from "./DataProvider.vue?vue&type=script&setup=true&lang=js&"
export * from "./DataProvider.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cac0be9",
  null
  
)

export default component.exports